import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=01614984&"
import script from "./Error.vue?vue&type=script&lang=ts&"
export * from "./Error.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports